/** The name of the root logger that is user in the index.tsx file */
export const ROOT_LOGGER_NAME = 'Root';
